<template>
  <v-container fluid>
    <v-row class="ma-0 pa-0" v-if="ToDo === 'false'">
      <v-col cols="9" class="ma-0 pa-0">
        <v-row class="ma-0 pa-0">
          <v-col v-if="!item.status" cols="4" v-for="item in ToDos" :key="item.id">
            <v-card>
              <v-card-title>
                {{ item.aufgabe }}
                <v-spacer></v-spacer>
                <v-chip>{{ $filters.date(item.bis, "DD.MM.YYYY") }}</v-chip>
              </v-card-title>
              <v-card-text>
                {{ item.beschreibung }}
              </v-card-text>
              <v-divider></v-divider>
              <v-card-actions>
                <v-chip v-if="item.wer">{{ item.wer }}</v-chip>
                <v-spacer></v-spacer>
                <v-btn icon @click="showModalEdit(item)"><v-icon>edit</v-icon></v-btn>
                <v-btn v-if="!item.status" icon @click="checkToDo(item)"><v-icon>check</v-icon></v-btn>
                <v-btn v-else icon @click="checkToDo(item)"><v-icon>close</v-icon></v-btn>
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="3" class="ma-0 pa-0">
        <v-simple-table dense height="calc(100vh - 216px)">
          <thead>
            <tr>
              <th>Erledigte Aufgabe</th>
              <th></th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr v-if="item.status" v-for="item in ToDos" :key="item.id">
              <td>{{ item.aufgabe }}</td>
              <td width="20px" class="pl-0 pr-2">
                <v-btn icon @click="checkToDo(item)"><v-icon>close</v-icon></v-btn>
              </td>
              <td width="20px" class="pl-0 pr-2">
                <v-btn icon @click="showModalEdit(item)"><v-icon>info</v-icon></v-btn>
              </td>
            </tr>
          </tbody>
        </v-simple-table>
      </v-col>
    </v-row>

    <v-card v-if="ToDo === 'true'" outlined>
      <v-card-title>ToDo hinzufügen</v-card-title>
      <v-row>
        <v-col cols="8">
          <v-text-field label="Aufgabe" v-model="aufgabe"></v-text-field>
        </v-col>
        <v-col cols="4">
          <v-menu
            ref="bis"
            v-model="menu"
            :close-on-content-click="false"
            :nudge-right="40"
            :return-value.sync="date"
            transition="scale-transition"
            offset-y
            min-width="290px"
          >
            <template v-slot:activator="{ on }">
              <v-text-field v-model="formatBis" label="Bis" readonly v-on="on"></v-text-field>
            </template>
            <v-date-picker
              prev-icon="keyboard_arrow_left"
              next-icon="keyboard_arrow_right"
              v-model="bis"
              locale="de-de"
              first-day-of-week="1"
              @input="menu = false"
              no-title
              scrollable
            >
            </v-date-picker>
          </v-menu>
        </v-col>
        <v-col cols="12">
          <v-textarea label="Beschreibung" v-model="beschreibung"></v-textarea>
        </v-col>
        <v-col cols="6">
          <v-checkbox
            class="mt-0 pt-0"
            on-icon="check_box"
            off-icon="check_box_outline_blank"
            v-model="senior"
            label="Senior"
          ></v-checkbox>
          <v-checkbox
            class="mt-0 pt-0"
            on-icon="check_box"
            off-icon="check_box_outline_blank"
            v-model="consenior"
            label="Consenior"
          ></v-checkbox>
          <v-checkbox
            class="mt-0 pt-0"
            on-icon="check_box"
            off-icon="check_box_outline_blank"
            v-model="fuxmajor"
            label="Fuxmajor"
          ></v-checkbox>
        </v-col>
        <v-col cols="6">
          <v-checkbox
            class="mt-0 pt-0"
            on-icon="check_box"
            off-icon="check_box_outline_blank"
            v-model="schriftführer"
            label="Schriftführer"
          ></v-checkbox>
          <v-checkbox
            class="mt-0 pt-0"
            on-icon="check_box"
            off-icon="check_box_outline_blank"
            v-model="kassierer"
            label="Kassierer"
          ></v-checkbox>
          <v-checkbox
            class="mt-0 pt-0"
            on-icon="check_box"
            off-icon="check_box_outline_blank"
            v-model="hauswart"
            label="Hauswart"
          ></v-checkbox>
        </v-col>
        <v-btn absolute dark fab bottom right color="primary" class="mb-12" @click="addToDo"
          ><v-icon>save</v-icon></v-btn
        >
      </v-row>
    </v-card>
    <v-dialog v-model="modalEdit" width="500" :fullscreen="$vuetify.breakpoint.smAndDown" persistent scrollable>
      <v-card>
        <v-card-title>
          {{ itemEdit.aufgabe }}
          <v-spacer></v-spacer>

          <v-btn icon @click="deleteToDo"><v-icon>delete</v-icon></v-btn>
        </v-card-title>

        <v-card-text>
          <v-row>
            <v-col cols="7">
              <v-text-field label="Aufgabe" v-model="aufgabe"></v-text-field>
            </v-col>
            <v-col cols="5">
              <v-menu
                ref="bis"
                v-model="menu"
                :close-on-content-click="false"
                :nudge-right="40"
                :return-value.sync="date"
                transition="scale-transition"
                offset-y
                full-width
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field v-model="formatBis" label="Bis" readonly v-on="on"></v-text-field>
                </template>
                <v-date-picker
                  prev-icon="keyboard_arrow_left"
                  next-icon="keyboard_arrow_right"
                  v-model="bis"
                  locale="de-de"
                  first-day-of-week="1"
                  @input="menu = false"
                  no-title
                  scrollable
                >
                </v-date-picker>
              </v-menu>
            </v-col>
            <v-col cols="12">
              <v-textarea label="Beschreibung" v-model="beschreibung"></v-textarea>
            </v-col>
            <v-col cols="6">
              <v-checkbox
                class="mt-0 pt-0"
                on-icon="check_box"
                off-icon="check_box_outline_blank"
                v-model="senior"
                label="Senior"
              ></v-checkbox>
              <v-checkbox
                class="mt-0 pt-0"
                on-icon="check_box"
                off-icon="check_box_outline_blank"
                v-model="consenior"
                label="Consenior"
              ></v-checkbox>
              <v-checkbox
                class="mt-0 pt-0"
                on-icon="check_box"
                off-icon="check_box_outline_blank"
                v-model="fuxmajor"
                label="Fuxmajor"
              ></v-checkbox>
            </v-col>
            <v-col cols="6">
              <v-checkbox
                class="mt-0 pt-0"
                on-icon="check_box"
                off-icon="check_box_outline_blank"
                v-model="schriftführer"
                label="Schriftführer"
              ></v-checkbox>
              <v-checkbox
                class="mt-0 pt-0"
                on-icon="check_box"
                off-icon="check_box_outline_blank"
                v-model="kassierer"
                label="Kassierer"
              ></v-checkbox>
            </v-col>
          </v-row>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="modalEdit = false">Abbrechen</v-btn>
          <v-btn color="primary" @click="updateToDo">Speichern</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
  export default {
    props: ["wer", "ToDo", "showTitle", "anzahl"],
    data() {
      return {
        expanded: [],
        singleExpand: true,
        headers: [
          { text: "", value: "data-table-expand" },
          { text: "Aufgabe", value: "aufgabe" },
          { text: "Bis", value: "bis" },
          { text: "Wer", value: "wer" },
          { text: "", value: "" },
          { text: "", value: "" },
        ],
        search: "",
        modalEdit: false,
        itemEdit: [],
        aufgabe: "",
        menu: false,
        date: "",
        bis: "",
        beschreibung: "",
        senior: false,
        consenior: false,
        fuxmajor: false,
        schriftführer: false,
        kassierer: false,
        hauswart: false,
        ToDos: [],
      };
    },
    computed: {
      formatBis() {
        if (!this.bis) return null;
        return new Date(this.bis).toLocaleString(["de-de"], { month: "short", day: "numeric", year: "2-digit" });
      },
    },
    methods: {
      showModalEdit(item) {
        this.modalEdit = !this.modalEdit;
        this.itemEdit = item;
        this.aufgabe = item.aufgabe;
        this.bis = item.bis;
        this.senior = item.senior;
        this.consenior = item.consenior;
        this.fuxmajor = item.fuxmajor;
        this.schriftführer = item.schriftführer;
        this.kassierer = item.kassierer;
        this.hauswart = item.hauswart;
        this.beschreibung = item.beschreibung;
      },
      checkToDo(item) {
        this.ToDos[this.ToDos.indexOf(item)].status = !this.ToDos[this.ToDos.indexOf(item)].status;
        this.$firebase
          .firestore()
          .collection("vereine")
          .doc(this.$vars.verbindung)
          .collection("todo")
          .doc(item.id)
          .update(item)
          .catch((error) => {
            console.log(error);
          });
      },
      updateToDo() {
        let item = {
          aufgabe: this.aufgabe,
          bis: this.bis,
          senior: this.senior,
          consenior: this.consenior,
          fuxmajor: this.fuxmajor,
          schriftführer: this.schriftführer,
          kassierer: this.kassierer,
          beschreibung: this.beschreibung,
        };
        this.$firebase
          .firestore()
          .collection("vereine")
          .doc(this.$vars.verbindung)
          .collection("todo")
          .doc(this.itemEdit.id)
          .update(item)
          .then((key) => {
            this.aufgabe = "";
            this.bis = "";
            this.beschreibung = "";
            this.senior = false;
            this.consenior = false;
            this.fuxmajor = false;
            this.schriftführer = false;
            this.kassierer = false;
            this.modalEdit = false;
          })
          .catch((error) => {
            console.log(error);
          });
      },
      deleteToDo() {
        this.$firebase
          .firestore()
          .collection("vereine")
          .doc(this.$vars.verbindung)
          .collection("todo")
          .doc(this.itemEdit.id)
          .delete()
          .then((key) => {
            this.modalEdit = false;
          })
          .catch((error) => {
            console.log(error);
          });
      },
      addToDo() {
        let item = {
          aufgabe: this.aufgabe,
          bis: this.bis,
          senior: this.senior,
          consenior: this.consenior,
          fuxmajor: this.fuxmajor,
          schriftführer: this.schriftführer,
          kassierer: this.kassierer,
          beschreibung: this.beschreibung,
        };
        this.$firebase
          .firestore()
          .collection("vereine")
          .doc(this.$vars.verbindung)
          .collection("todo")
          .add(item)
          .then((key) => {
            this.aufgabe = "";
            this.bis = "";
            this.beschreibung = "";
            this.senior = false;
            this.consenior = false;
            this.fuxmajor = false;
            this.schriftführer = false;
            this.kassierer = false;
          })
          .catch((error) => {
            console.log(error);
          });
      },
    },
    beforeMount() {
      this.$firebase
        .firestore()
        .collection("vereine")
        .doc(this.$vars.verbindung)
        .collection("todo")
        .orderBy("bis")
        .onSnapshot(
          (querySnapshot) => {
            this.ToDos = [];
            switch (this.wer) {
              case "senior":
                querySnapshot.forEach((doc) => {
                  if (doc.data().senior) {
                    this.ToDos.push({
                      id: doc.id,
                      aufgabe: doc.data().aufgabe,
                      senior: doc.data().senior,
                      consenior: doc.data().consenior,
                      fuxmajor: doc.data().fuxmajor,
                      schriftführer: doc.data().schriftführer,
                      kassierer: doc.data().kassierer,
                      hauswart: doc.data().hauswart,
                      bis: doc.data().bis,
                      beschreibung: doc.data().beschreibung,
                      status: doc.data().status,
                    });
                  }
                });
                break;
              case "consenior":
                querySnapshot.forEach((doc) => {
                  if (doc.data().consenior) {
                    this.ToDos.push({
                      id: doc.id,
                      aufgabe: doc.data().aufgabe,
                      senior: doc.data().senior,
                      consenior: doc.data().consenior,
                      fuxmajor: doc.data().fuxmajor,
                      schriftführer: doc.data().schriftführer,
                      kassierer: doc.data().kassierer,
                      hauswart: doc.data().hauswart,
                      bis: doc.data().bis,
                      beschreibung: doc.data().beschreibung,
                      status: doc.data().status,
                    });
                  }
                });
                break;
              case "fuxmajor":
                querySnapshot.forEach((doc) => {
                  if (doc.data().fuxmajor) {
                    this.ToDos.push({
                      id: doc.id,
                      aufgabe: doc.data().aufgabe,
                      senior: doc.data().senior,
                      consenior: doc.data().consenior,
                      fuxmajor: doc.data().fuxmajor,
                      schriftführer: doc.data().schriftführer,
                      kassierer: doc.data().kassierer,
                      hauswart: doc.data().hauswart,
                      bis: doc.data().bis,
                      beschreibung: doc.data().beschreibung,
                      status: doc.data().status,
                    });
                  }
                });
                break;
              case "schriftfuhrer":
                querySnapshot.forEach((doc) => {
                  if (doc.data().schriftführer) {
                    this.ToDos.push({
                      id: doc.id,
                      aufgabe: doc.data().aufgabe,
                      senior: doc.data().senior,
                      consenior: doc.data().consenior,
                      fuxmajor: doc.data().fuxmajor,
                      schriftführer: doc.data().schriftführer,
                      kassierer: doc.data().kassierer,
                      hauswart: doc.data().hauswart,
                      bis: doc.data().bis,
                      beschreibung: doc.data().beschreibung,
                      status: doc.data().status,
                    });
                  }
                });
                break;
              case "kassierer":
                querySnapshot.forEach((doc) => {
                  if (doc.data().kassierer) {
                    this.ToDos.push({
                      id: doc.id,
                      aufgabe: doc.data().aufgabe,
                      bis: doc.data().bis,
                      senior: doc.data().senior,
                      consenior: doc.data().consenior,
                      fuxmajor: doc.data().fuxmajor,
                      schriftführer: doc.data().schriftführer,
                      kassierer: doc.data().kassierer,
                      beschreibung: doc.data().beschreibung,
                      status: doc.data().status,
                    });
                  }
                });
                break;
              case "alle":
                querySnapshot.forEach((doc) => {
                  let wer = "";
                  if (doc.data().senior) {
                    wer = wer + "X, ";
                  }
                  if (doc.data().consenior) {
                    wer = wer + "XX, ";
                  }
                  if (doc.data().fuxmajor) {
                    wer = wer + "FM, ";
                  }
                  if (doc.data().schriftführer) {
                    wer = wer + "XXX, ";
                  }
                  if (doc.data().kassierer) {
                    wer = wer + "XXXX, ";
                  }
                  wer = wer.substr(0, wer.length - 2);
                  this.ToDos.push({
                    id: doc.id,
                    aufgabe: doc.data().aufgabe,
                    bis: doc.data().bis,
                    wer: wer,
                    senior: doc.data().senior,
                    consenior: doc.data().consenior,
                    fuxmajor: doc.data().fuxmajor,
                    schriftführer: doc.data().schriftführer,
                    kassierer: doc.data().kassierer,
                    beschreibung: doc.data().beschreibung,
                    status: doc.data().status,
                  });
                });
                break;
              default:
                return 0;
            }
          },
          (err) => {
            console.log(`Encountered error: ${err}`);
          }
        );
    },
  };
</script>

<style scoped></style>



// WEBPACK FOOTER //
// todoSeite.vue?4a0fcaa0